import { motion } from "framer-motion";

const CHAPTERS = [
  {
    no: "01",
    title: "100% Fiber Optic",
    desc: "Bukan kabel tembaga, bukan sinyal seluler yang drop saat hujan. Kabel serat optik digelar langsung ke dalam rumah Anda (FTTH) untuk stabilitas maksimum.",
    accent: "text-cyan-400",
    hover: "hover:border-cyan-400/40",
  },
  {
    no: "02",
    title: "Tanpa Kuota FUP",
    desc: "Download dan upload seimbang. Video call jernih, main game tanpa lag, streaming 4K sepuasnya — tanpa takut kuota habis di tengah bulan.",
    accent: "text-[#FF6B35]",
    hover: "hover:border-[#F04E23]/40",
  },
  {
    no: "03",
    title: "ISP Lokal Resmi Kalbar",
    desc: "Dikelola PT. Fasnet Sky Fiber dengan Autonomous System AS152793 resmi. Teknisi dan CS lokal siap merespons cepat langsung di area tempat tinggal Anda.",
    accent: "text-[#6FA5EE]",
    hover: "hover:border-[#2563EB]/40",
  },
];

export default function Manifesto() {
  return (
    <section id="keunggulan" data-testid="manifesto-section" className="relative pb-4 pt-12 sm:pb-6 sm:pt-16">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          className="font-mono text-xs tracking-[0.25em] text-cyan-400"
        >
          PT. FASNET SKY FIBER - INTERNET UNTUK SEMUA
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ delay: 0.1 }}
          className="mt-4 font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl lg:text-4xl"
        >
          Kami Membangun Jaringan Internet di Kalimantan Barat.
        </motion.h2>

        <div className="mt-8 grid gap-3 md:mt-10 md:grid-cols-3 md:gap-4">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.no}
              data-testid={`manifesto-chapter-${c.no}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.12, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className={`group flex items-center gap-4 rounded-2xl border border-white/10 bg-[#0A1124]/60 p-4 transition-colors duration-300 md:p-5 ${c.hover}`}
            >
              <p className={`shrink-0 font-mono text-3xl font-extrabold md:text-4xl ${c.accent}`}>{c.no}</p>
              <h3 className="font-display text-base font-bold text-white md:text-lg">{c.title}</h3>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
